import { initActionButtonWebComponent } from "components/actionButton/actionButtonElement";
import { initCalendarIconWebComponent } from "components/input/date/calendarIconElement";
import { initCheckboxInputWebComponent } from "components/input/checkbox/checkboxElement";
import { initCodeInputWebComponent } from "components/input/code/codeElement";
import { initComposedTextTokenWebComponent } from "components/input/multivalueText/components/composedTextToken";
import { initGroupValueTextTokenWebComponent } from "components/input/token/groupValueTextToken";
import { initDateInputWebComponent } from "components/input/date/dateElement";
import { initLabelWebComponent } from "./label/labelElement";
import { initMenuWebComponent } from "components/menu/menuElement";
import { initMultivalueWebComponent } from "components/input/multivalueText/components/multivalue";
import { initTextOutputWebComponent } from "components/output/text/textElement";
import { initTextTokenWebComponent } from "components/input/multivalueText/components/textToken";
import { initTooltipBodyWebComponent } from "./tooltip/tooltipBodyElement";
import { initTooltipWebComponent } from "./tooltip/tooltipElement";
import { initTooltipWebDataTipComponent } from "./tooltip/tooltipElementDataTip";
import { initOverlayWebComponent } from "components/input/overlay/overlay";
import { initValueTextTokenWebComponent } from "components/input/token/valueTextToken";


export function initSislo6WebComponents() {
    initActionButtonWebComponent();
    initCalendarIconWebComponent();
    initCheckboxInputWebComponent();
    initCodeInputWebComponent();
    initComposedTextTokenWebComponent();
    initGroupValueTextTokenWebComponent();
    initDateInputWebComponent();
    initLabelWebComponent();
    initMenuWebComponent();
    initMultivalueWebComponent();
    initTextOutputWebComponent();
    initTextTokenWebComponent();
    initTooltipBodyWebComponent();
    initTooltipWebDataTipComponent();
    initTooltipWebComponent();
    initOverlayWebComponent();
    initValueTextTokenWebComponent();

}
